import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import {
  BannerComponent,
  Card,
  Checkbox,
  IconList,
  LevelNav,
  ProgressBar,
} from 'common/components';

const StoragesForm = props => {
  const {
    handleSubmit,
    onSubmit,
    storages,
    selectedCrop,
    selectedStorage,
  } = props;

  const getContent = storage => {
    let list = [];
    if (storage.crop) {
      list.push({
        label: `${storage.crop.name} ${
          storage.crop.variety ? storage.crop.variety : ''
        }`,
        icon: 'crop',
      });
    }
    list.push({ label: `${storage.contentValue.value}`, icon: 'dollar' });
    return list;
  };

  const match = selectedCrop && JSON.parse(selectedCrop);
  let selectedStorages = match
    ? storages.filter(
        storage =>
          !storage.crop ||
          (storage.crop &&
            storage.crop.name === match.name &&
            Number(storage.capacity.size) - Number(storage.capacity.used) > 0)
      )
    : storages;

  // don't show selected single storage
  if (selectedStorages && selectedStorage) {
    const selectedObj = JSON.parse(selectedStorage);
    selectedStorages = selectedStorages.filter(
      storage => storage.id !== selectedObj.id
    );
  }

  // free space order for now
  if (selectedStorages && selectedStorages.legnth > 1) {
    selectedStorages.sort(
      (a, b) => b.capacity.pending.size - a.capacity.pending.size
    );
  }

  return (
    <Fragment>
      <BannerComponent
        theme={['static', 'strong', 'large', 'mobile-fixed']}
        message={
          <LevelNav
            nav={{
              left: {
                label: <span className={'visible--desktop'}>Back</span>,
                action: () => onSubmit(),
              },
              center: { label: 'Add Storage' },
            }}
          />
        }
      />

      <form onSubmit={handleSubmit(onSubmit)}>
        {selectedStorages && selectedStorages.length === 0 && (
          <p className={'text--center text--medium'}>
            No Storages with {match.name} {match.variety}
          </p>
        )}

        {selectedStorages && selectedStorages.length > 0 && (
          <Fragment>
            <p className={'text--fade'}>
              <small>Select storage from the list below to add.</small>
            </p>

            <div className={'field'}>
              {storages && (
                <Checkbox
                  name={'storages'}
                  theme={['card']}
                  options={selectedStorages.map(storage => {
                    const { id, name, capacity } = storage;
                    return {
                      value: JSON.stringify({
                        id,
                        name,
                        type: id.split(':')[0],
                        max: Number(capacity.size) - Number(capacity.used),
                      }),
                      label: (
                        <Card
                          footer={
                            capacity && (
                              <ProgressBar
                                value={capacity.used}
                                max={capacity.size}
                                unit={capacity.type.slice(0, 2)}
                              />
                            )
                          }
                        >
                          <h3 className={'cardlist__title'}>{name}</h3>
                          <IconList list={getContent(storage)} />
                        </Card>
                      ),
                    };
                  })}
                />
              )}
            </div>
          </Fragment>
        )}
      </form>
    </Fragment>
  );
};

StoragesForm.propTypes = {
  // from redux form
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,

  // from mapstate
  selectedCrop: PropTypes.string,
  selectedStorage: PropTypes.string,

  // manually added
  onSubmit: PropTypes.func.isRequired,
  storages: PropTypes.arrayOf(PropTypes.object),
};

const formSettings = {
  form: 'activityform',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onChange: (values, dispatch, props, prevValues) => {
    props.populateAmount('storages', values, dispatch, prevValues);
  },
};
const field = formValueSelector(formSettings.form);
const mapState = state => ({
  selectedCrop: field(state, 'crop'),
  selectedStorage: field(state, 'storage'),
});
export default compose(
  connect(mapState),
  reduxForm(formSettings)
)(StoragesForm);



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/forms/Storages.js